import { Navigate, Outlet, useOutletContext, useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { TrainingsEmployeesRootPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import type { RouteContext } from 'modules/employees/lib/types'
import PageLoading from 'modules/layout/components/Page/Loading'
import CollectionsBootstrap from 'modules/trainings/lib/EmployeesCollectionsBootstrap'

const Container = () => {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const context = useOutletContext<RouteContext>()
  const { employee } = context
  const { loading, data } = useQuery(TrainingsEmployeesRootPageDocument, {
    variables: {
      id: Number(id),
    },
  })

  if (loading) {
    return (
      <Box width="full" height="full" justifyContent="center" alignItems="center">
        <PageLoading />
      </Box>
    )
  }

  if (!employee || !data?.employees?.employee?._policies?.seeEmployeeTrainings.can) {
    return <Navigate replace to={navigation.employees.id.fullPath({ id: String(id) })} />
  }

  return <Outlet context={context} />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
